import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default from 'react';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Link } from '../Link/Link.es.js';

const baseButton = "_base-button_1w43g_1";
const buttonContent = "_button-content_1w43g_529";
const buttonText = "_button-text_1w43g_537";
const buttonIcon = "_button-icon_1w43g_545";
const styles = {
	baseButton: baseButton,
	buttonContent: buttonContent,
	buttonText: buttonText,
	buttonIcon: buttonIcon
};

const ButtonIcon = (props) => React__default.createElement(
  "span",
  { className: styles.buttonIcon, "data-has-sibling": props.hasSibling, "data-zds": true },
  React__default.createElement(Icon, { canAcceptPointerEvents: false, isBlock: true, name: props.iconName, size: props.size })
);
const ButtonText = (props) => React__default.createElement("span", { className: styles.buttonText, "data-zds": true }, props.children);
const ButtonContent = (props) => {
  return React__default.createElement(
    "span",
    { className: styles.buttonContent, "data-zds": true },
    props.iconBefore && React__default.createElement(ButtonIcon, { hasSibling: !!props.children, iconName: props.iconBefore, size: 24 }),
    React__default.createElement(ButtonText, null, props.children)
  );
};
const getTag = (props) => {
  if (props.presentationOnly) {
    return "span";
  }
  if (props.htmlFor && !props.disabled) {
    return "label";
  }
  if (props.href && !props.disabled) {
    return Link;
  }
  return "button";
};
function BaseButton(_a) {
  var { disabled = false, isFullWidth = false, isPill = false } = _a, otherProps = __rest(_a, ["disabled", "isFullWidth", "isPill"]);
  const props = Object.assign({
    disabled,
    isFullWidth,
    isPill
  }, otherProps);
  const ButtonTag = getTag(props);
  const isLink = ButtonTag === Link;
  return React__default.createElement(
    ButtonTag,
    {
      "aria-controls": props["aria-controls"],
      "aria-describedby": props["aria-describedby"],
      "aria-disabled": props["disabled"],
      "aria-expanded": props["aria-expanded"],
      "aria-haspopup": props["aria-haspopup"],
      "aria-hidden": props["aria-hidden"],
      "aria-label": props["aria-label"],
      className: styles.baseButton,
      // @ts-ignore TS doesn't understand Link[color=null]
      color: isLink ? null : void 0,
      "data-a11y-ignore": props.color === "brand" ? "color-contrast" : void 0,
      "data-color": props.color,
      "data-icon": props.iconBefore ? "before" : void 0,
      "data-full-width": props.isFullWidth ? "" : void 0,
      "data-pill": props.isPill ? "" : void 0,
      "data-selected": props.isSelected ? "" : void 0,
      "data-shadowed": props.hasShadow ? "" : void 0,
      "data-size": props.size,
      "data-square": props.isSquare ? "" : void 0,
      "data-zds": true,
      disabled: props.disabled,
      htmlFor: props.htmlFor,
      href: isLink ? props.href : void 0,
      id: props.id,
      onClick: props.onClick,
      onKeyDown: props.onKeyDown,
      rel: isLink ? props.rel : void 0,
      role: !isLink ? "button" : void 0,
      tabIndex: props.tabIndex,
      target: isLink ? props.target : void 0,
      type: ButtonTag === "button" ? props.type : void 0
    },
    React__default.createElement(ButtonContent, Object.assign({}, props))
  );
}

export { BaseButton };
//# sourceMappingURL=BaseButton.es.js.map
